'use strict';

import assign from 'object-assign';
import _ from 'lodash';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import YourDetailsConstants from '../constants/YourDetailsConstants.js';
import Products from '../utils/Products.js';
const isAdviser = () => !!(window.NOA && window.NOA.userContext && window.NOA.userContext.isAdviser);

class YourDetailsValidationsClass{
    constructor(){
        this._validations = YourDetailsConstants.Validations;
    }
    _isCountryAu(value){
        return value === YourDetailsConstants.Values.COUNTRY_AUSTRALIA;
    }
    _removeRequired(rule){
        var req = 'required|';
        return (rule.indexOf(req) !== -1) ? rule.substring(req.length) : rule;
    }
    _businessForSave(rule) {
        assign(rule, this._validations.businessSave);
    }
    _individualForSave(rule) {
        assign(rule, this._validations.personalInfoSave);
    }
    _super(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, 
               this._validations.tfn, this._validations.countryResidence, this._validations.occupation);
        rule.tfnNumber = this._removeRequired(rule.tfnNumber);
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
        delete rule.tfnExemptionReason;
    }
    _pension(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, 
               this._validations.tfn, this._validations.countryResidence, this._validations.taxResident, this._validations.occupation);
        rule.dateOfBirth += '|pensionDobMinimumAge';
        rule.tfnNumber = this._removeRequired(rule.tfnNumber);
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
        delete rule.tfnExemptionReason;
        delete rule.isOtherCountryTaxResident;
    }
    _individualInvestment(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, 
               this._validations.tfn, this._validations.countryResidence,this._validations.AustralianTaxResident, this._validations.taxResident, 
               this._validations.citizenship, this._validations.occupation, this._validations.tin, 
               this._validations.accountDesignation, this._validations.sourceOfFund, this._validations.sourceOfWealth);
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
        rule.dateOfBirth += '|investmentDobMinimumAge';
        delete rule.isAustralianResident;
    }
    _individualAnnuity(rule, isComminsure){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, 
                       this._validations.tfn, this._validations.countryResidence, this._validations.taxResident, 
                       this._validations.citizenship, this._validations.occupation,
                       this._validations.accountDesignation);
        rule.dateOfBirth += (isComminsure) ? '|comminsureDobMinimumAge' : '|challengerDobMinimumAge';
        delete rule.isAustralianResident;
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
    }
    _companyInvestmentMain(rule){
        var contactDetails = {
            workNumber: this._validations.contactDetails.workNumber,
            homeNumber: this._validations.contactDetails.homeNumber,
            emailAddress: this._validations.contactDetails.emailAddress
        }

        assign(rule, this._validations.business, {abn: 'abnArbnArsnExactLength|abnAcn'}, this._validations.tfn, contactDetails, this._validations.accountDesignation);
        rule.workNumber += '|required';
        rule.emailAddress += '|required';
    
    }
    _companyAnnuityMain(rule){
        assign(rule, this._validations.business, this._validations.tfn, {abn: 'abnArbnExactLength|abnAcn'}, this._validations.contactDetails, this._validations.accountDesignation);
        delete rule.isPrimaryBusinessInvesting;
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
    }
    _companyInvestor(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails);
        rule.dateOfBirth += '|investmentDobMinimumAge';
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
    }
    _trustInvestmentMain(rule){
        assign(rule, this._validations.business, this._validations.tfn, this._validations.contactDetails, this._validations.accountDesignation);            
        delete rule.homeNumber;
        delete rule.workNumber;
        rule.mobileNumber += '|required';
        rule.emailAddress += '|required';
    }
    _trustAnnuityMain(rule){
        assign(rule, this._validations.business, this._validations.tfn, this._validations.contactDetails, this._validations.accountDesignation);
        delete rule.isPrimaryBusinessInvesting;
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
    }
    _smsfInvestmentMain(rule){
        assign(rule, this._validations.business, this._validations.tfn, this._validations.contactDetails, this._validations.accountDesignation);
        rule.tfnNumber = this._removeRequired(rule.tfnNumber);
        delete rule.isCharity;
        rule.mobileNumber += '|required';
        rule.emailAddress += '|required';
    }
    _smsfAnnuityMain(rule){
        assign(rule, this._validations.business, this._validations.tfn, this._validations.contactDetails, this._validations.accountDesignation);
        delete rule.isCharity;
        delete rule.isPrimaryBusinessInvesting;
    }
    _partnershipInvestmentMain(rule){
        assign(rule, this._validations.business, {abn: 'abnArbnArsnExactLength|abnAcn'}, this._validations.tfn, this._validations.contactDetails, this._validations.accountDesignation);
        rule.tfnNumber = this._removeRequired(rule.tfnNumber);
        rule.mobileNumber += '|required';
        rule.emailAddress += '|required';
    }
    _individualInvestmentTrustee(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, 
               this._validations.countryResidence, this._validations.AustralianTaxResident, this._validations.taxResident, 
               this._validations.citizenship, this._validations.occupation, this._validations.tin);
        rule.dateOfBirth += '|investmentDobMinimumAge';
        delete rule.isAustralianResident;
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
    }
    _individualAnnuityTrustee(rule, isComminsure){
        assign(rule, this._validations.personalInfo, this._validations.occupation, this._validations.countryResidence, 
                    this._validations.tfn, this._validations.taxResident, this._validations.citizenship, this._validations.contactDetails);
        rule.dateOfBirth += (isComminsure) ? '|comminsureDobMinimumAge' : '|challengerDobMinimumAge';
        delete rule.isAustralianResident;
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
    }
    _individualInvestmentSmsf(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, this._validations.tfn,
               this._validations.countryResidence, this._validations.AustralianTaxResident, this._validations.taxResident, 
               this._validations.citizenship, this._validations.occupation, this._validations.tin);
        rule.dateOfBirth += '|investmentDobMinimumAge';
        delete rule.isAustralianResident;
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
    }
    _corporateInvestmentTrustee(rule){
        var corporateTrustee = {corporateTrustee: this._validations.business.businessName};
        assign(rule, corporateTrustee, {abn: 'abnAcnExactLength|abnAcn'}, this._validations.contactDetails);
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
    }
    _corporateSMSFInvestmentTrustee(rule){
        var corporateTrustee = {corporateTrustee: this._validations.business.businessName};
        assign(rule, corporateTrustee, {abn: 'abnAcnArsnExactLength|abnAcn'}, this._validations.contactDetails);
        delete rule.tfnConsentFlag;
        delete rule.tfnWithConsent;
    }
    _companyInvestmentCustomAttribute(customAttribute, forSave){
        customAttribute.businessName = 'full name of company';
        if (forSave) {
            return;
        }
        customAttribute.abn = 'ABN/ARBN/ARSN';
    }
    _companyAnnuityCustomAttribute(customAttribute, forSave){
        this._companyInvestmentCustomAttribute(customAttribute, forSave);
        if (forSave) {
            return;
        }
        customAttribute.abn = 'ABN/ARBN';
    }
    _trustInvestmentCustomAttribute(customAttribute, forSave){
        customAttribute.businessName = 'full name of trust';
        if (forSave) {
            return;
        }
        customAttribute.primaryBusinessActivity = 'primary trust activity';
        customAttribute.otherCountryTaxResidence = 'country of tax residence'
        customAttribute.abn = 'ABN/ACN';
    }
    _smsfInvestmentCustomAttribute(customAttribute, forSave){
        customAttribute.businessName = 'full name of super fund';
        if (forSave) {
            return;
        }

        customAttribute.primaryBusinessActivity = 'primary trust activity';
        customAttribute.otherCountryTaxResidence = 'country of tax residence'
        customAttribute.abn = 'ABN/ACN/ARSN';
    }
    _individualAnnuityCustomAttribute(customAttribute, forSave){
        if (forSave) {
            return;
        }

        customAttribute.otherCountryTaxResidence = 'country of tax residence'
    }
    _partnershipInvestmentCustomAttribute(customAttribute, forSave){
        customAttribute.businessName = 'full name of partnership';
        if (forSave) {
            return;
        }
        customAttribute.abn = 'ABN/ARBN/ARSN';
    }
    _soleTrader(rule, isExistingCustomer, hasCustomTitle){
        assign(rule, this._validations.personalInfo, this._validations.contactDetails, this._validations.tfn, this._validations.countryResidence, this._validations.AustralianTaxResident, this._validations.taxResident,
                     this._validations.citizenship, this._validations.business, this._validations.abn, this._validations.occupation, this._validations.tin, 
                     this._validations.accountDesignation, this._validations.sourceOfFund, this._validations.sourceOfWealth);
        rule.tfnNumber = this._removeRequired(rule.tfnNumber);
        rule.dateOfBirth += '|investmentDobMinimumAge';
        if (isExistingCustomer) {
            rule.givenName = 'required';
            rule.lastName = 'required';
            if (hasCustomTitle) {
                delete rule.title;
            }
        }
        delete rule.isAustralianResident;
        delete rule.primaryBusinessActivity;
        delete rule.isCharity;
        delete rule.isPrimaryBusinessInvesting;
        delete rule.countryEstablished;
    }

    getRulesForSave (formKey){
        var rule = {};
        let productIds = ApplicationConstants.ProductIds;
        let formKeys = ApplicationConstants.FormKeys;
        switch(formKey){
            case productIds.SUPER:
            case productIds.PENSION:
            case formKeys.INDIVIDUAL_INVESTMENT:
            case formKeys.INDIVIDUAL_COMMINSURE:
            case formKeys.INDIVIDUAL_CHALLENGER:
            case formKeys.JOINT_INVESTMENT:
            case formKeys.JOINT_COMMINSURE:
            case formKeys.JOINT_CHALLENGER:
            case formKeys.SOLE_TRADER_INVESTMENT:
                this._individualForSave(rule);
                break;
            case formKeys.TRUST_INVESTMENT:
            case formKeys.TRUST_COMMINSURE:
            case formKeys.TRUST_CHALLENGER:
            case formKeys.SMSF_INVESTMENT:
            case formKeys.SMSF_CHALLENGER:
            case formKeys.SMSF_COMMINSURE:
            case formKeys.PARTNERSHIP_INVESTMENT:
            case formKeys.COMPANY_INVESTMENT:
            case formKeys.COMPANY_CHALLENGER:
            case formKeys.COMPANY_COMMINSURE:
                this._businessForSave(rule);
                break;
            default:
                break;
        }
        return rule;
    }

    getRules (formKey, isExistingCustomer, hasCustomTitle, record){
        var rule = {};
        let productIds = ApplicationConstants.ProductIds;
        let formKeys = ApplicationConstants.FormKeys;
        switch(formKey){
            case productIds.SUPER:
                this._super(rule, isExistingCustomer, hasCustomTitle);
                break;
            case productIds.PENSION:
                this._pension(rule, isExistingCustomer, hasCustomTitle);
                break;
            case formKeys.INDIVIDUAL_INVESTMENT:
            case formKeys.JOINT_INVESTMENT:
                this._individualInvestment(rule, isExistingCustomer, hasCustomTitle);
                break;
            case formKeys.INDIVIDUAL_COMMINSURE:
            case formKeys.JOINT_COMMINSURE:
                this._individualAnnuity(rule, true);
                break;
            case formKeys.INDIVIDUAL_CHALLENGER:
            case formKeys.JOINT_CHALLENGER:
                this._individualAnnuity(rule);
                break;
            case formKeys.PARTNERSHIP_INVESTMENT:
                this._companyInvestor(rule, isExistingCustomer, hasCustomTitle);
                break;
            case formKeys.COMPANY_INVESTMENT:
                this._companyInvestor(rule, isExistingCustomer, hasCustomTitle);
                break;
            case formKeys.SOLE_TRADER_INVESTMENT:
                this._soleTrader(rule, isExistingCustomer);
                break;
            default:
                break;
        }

        if (formKey != formKeys.INDIVIDUAL_COMMINSURE && formKey != formKeys.JOINT_COMMINSURE && formKey !=formKeys.INDIVIDUAL_CHALLENGER && formKey != formKeys.JOINT_CHALLENGER)
        {
         rule = this.validationRulesForContactDetails(rule, record);
        }
        return rule;
    }
    getTrusteeRules (formKey, trusteeType, record, productId, isExistingCustomer, hasCustomTitle){
        var rule = {};
        let formKeys = ApplicationConstants.FormKeys;
        switch(formKey){
            case formKeys.SMSF_INVESTMENT:
                if (trusteeType === YourDetailsConstants.TrusteeType.CORPORATE){
                    this._corporateSMSFInvestmentTrustee(rule);
                }
                else {
                    this._individualInvestmentSmsf(rule, isExistingCustomer, hasCustomTitle);
                }
                break;
            case formKeys.SMSF_COMMINSURE:
            case formKeys.TRUST_COMMINSURE:
                this._individualAnnuityTrustee(rule, true);
                break;
            case formKeys.SMSF_CHALLENGER:
            case formKeys.TRUST_CHALLENGER:
                this._individualAnnuityTrustee(rule);
                break;
            case formKeys.TRUST_INVESTMENT:
                if (trusteeType === YourDetailsConstants.TrusteeType.CORPORATE){
                    this._corporateInvestmentTrustee(rule);
                }
                else {
                    this._individualInvestmentTrustee(rule, isExistingCustomer, hasCustomTitle);
                }
                break;
            default:
                break;
        }

        if (formKey != formKeys.SMSF_COMMINSURE && formKey !=formKeys.TRUST_COMMINSURE && formKey != formKeys.SMSF_CHALLENGER && formKey != formKeys.TRUST_CHALLENGER)
        {
          rule = this.validationRulesForContactDetails(rule, record);
        }
        return this.validationRulesInit(rule, record, productId);
    }
    getRulesForBusiness(formKey){
        var rule = {};
        let formKeys = ApplicationConstants.FormKeys;
        switch(formKey){
            case formKeys.COMPANY_INVESTMENT:
                this._companyInvestmentMain(rule);
                break;
            case formKeys.TRUST_INVESTMENT:
                this._trustInvestmentMain(rule);
                break;
            case formKeys.TRUST_COMMINSURE:
            case formKeys.TRUST_CHALLENGER:
                this._trustAnnuityMain(rule);
                break;
            case formKeys.SMSF_INVESTMENT:
                this._smsfInvestmentMain(rule);
                break;
            case formKeys.SMSF_CHALLENGER:
            case formKeys.SMSF_COMMINSURE:
                this._smsfAnnuityMain(rule);
                break;
            case formKeys.PARTNERSHIP_INVESTMENT:
                this._partnershipInvestmentMain(rule);
                break;
            case formKeys.COMPANY_CHALLENGER:
            case formKeys.COMPANY_COMMINSURE:
                this._companyAnnuityMain(rule);
                break;
            default:
                break;
        }
        return rule;
    }
    _getCustomAttributeNames(forSave){
        return forSave === true ?
            {
                givenName: 'given name(s)',
                lastName: 'last name',
                businessName: 'full business name'
            } : 
            {
                gender: 'gender',
                title: 'title',
                givenName: 'given name(s)',
                lastName: 'last name',
                dateOfBirth: 'date of birth',
                mobileNumber: 'mobile number',
                homeNumber: 'home phone number',
                workNumber: 'work phone number',
                emailAddress: 'email address',        
                tfnNumber: 'Tax File Number',
                tfnWithConsent: 'Tax File Number',
                tfnConsentFlag: 'Applicant consent received to reuse TFN',
                tfnExemptionReason: 'TFN exemption reason',
                tin1: 'Tax Identification Number',
                tin2: 'Tax Identification Number',
                tin3: 'Tax Identification Number',
                tinExemptionReason1: 'TIN exemption reason',
                tinExemptionReason2: 'TIN exemption reason',
                tinExemptionReason3: 'TIN exemption reason',
                hasTinExemptionReason1: 'Tax Identification number (TIN) or exemption reason',
                hasTinExemptionReason2: 'Tax Identification number (TIN) or exemption reason',
                hasTinExemptionReason3: 'Tax Identification number (TIN) or exemption reason',
                abn: 'ABN',
                businessName: 'full business name',
                partnershipName: 'full name of partnership',
                primaryBusinessActivity: 'primary business activity',
                isPrimaryBusinessInvesting: 'is the entity\'s primary business activity investing?',
                isAustralianResident: 'residential status',
                countryOfResidence: 'main country of residence',
                sourceOfFund: 'source of funds',
                sourceOfWealth: 'source of wealth',
                otherSourceOfFund: 'source of funds',
                otherSourceOfWealth: 'source of wealth',
                otherCountryTaxResidence1: 'country of residence for tax purposes',
                otherCountryTaxResidence2: 'country of residence for tax purposes',
                otherCountryTaxResidence3: 'country of residence for tax purposes',
                occupation: 'occupation information',
                isOtherCountryTaxResident: 'tax residence information',
                isCitizenOfOtherCountry: 'citizenship information',
                citizenship1: 'citizenship 1',
                isCharity: 'is this a charity?',
                countryEstablished: 'country established',
                corporateTrustee: 'full name of corporate trustee',
                trusteeType: 'trustee type',
                accountDesignationName: 'Account designation',
                isAustralianTaxResident: 'Australian Tax Residence information'
            };
    }
    getCustomAttributeNames(formKey, forSave){
        let formKeys = ApplicationConstants.FormKeys;
        let customAttribute = this._getCustomAttributeNames(forSave);
        switch(formKey){
            case formKeys.COMPANY_INVESTMENT:
                this._companyInvestmentCustomAttribute(customAttribute, forSave);
                break;
            case formKeys.TRUST_INVESTMENT:
            case formKeys.TRUST_COMMINSURE:
            case formKeys.TRUST_CHALLENGER:
                this._trustInvestmentCustomAttribute(customAttribute, forSave);
                break;
            case formKeys.SMSF_INVESTMENT:
            case formKeys.SMSF_CHALLENGER:
            case formKeys.SMSF_COMMINSURE:
                this._smsfInvestmentCustomAttribute(customAttribute, forSave);
                break;
            case formKeys.INDIVIDUAL_CHALLENGER:
            case formKeys.INDIVIDUAL_COMMINSURE:
            case formKeys.JOINT_CHALLENGER:
            case formKeys.JOINT_COMMINSURE:
                this._individualAnnuityCustomAttribute(customAttribute, forSave);
                break;
            case formKeys.PARTNERSHIP_INVESTMENT:
                this._partnershipInvestmentCustomAttribute(customAttribute, forSave);
                break;
            case formKeys.COMPANY_COMMINSURE:
            case formKeys.COMPANY_CHALLENGER:
                this._companyAnnuityCustomAttribute(customAttribute, forSave);
                break;
            default:
                break;
        }
        return customAttribute;
    }
    getAddressRules(){
        return {address: this._validations.address, postalAddress: this._validations.postalAddress}
    }
    _getAddressCustomAttributeNames(addressInfo){
        return {
            residential: 'residential address',
            address1: 'address line 1',
            address2: 'address line 2',
            cityStatePostCode: this._isCountryAu(addressInfo.resCountry) ? 'City/Suburb' : 'City/State/Postcode',
            resCountry: 'Country',
            resAusState: 'state',
            postCode: 'post code',
            isResPostalAdd: 'postal address',
            postal: 'postal address',
            postalCountry: 'Country',
            postalAddress1: 'address line 1',
            postalAddress2: 'address line 2',
            postalCityStatePostCode: this._isCountryAu(addressInfo.postalCountry) ? 'City/Suburb' : 'City/State/Postcode',
            postalAusState: 'state',
            postalPostCode: 'post code'
        };
    }
    getAddressCustomAttributeNamesForBusiness(addressInfo){
        if (!addressInfo){
            return;
        }
        let customAttribute = this._getAddressCustomAttributeNames(addressInfo);
        customAttribute.residential = 'registered office address/principal place of business';
        return customAttribute;
    }
    getAddressCustomAttributeNames(addressInfo){
        if (!addressInfo){
            return;
        }
        return this._getAddressCustomAttributeNames(addressInfo);
    }
    getAddressCustomAttributeNamesForSoleTrader(addressInfo){
        if (!addressInfo){
            return;
        }
        let customAttribute = this._getAddressCustomAttributeNames(addressInfo);
        customAttribute.residential = 'Full address of principal place of business';
        return customAttribute;
    }
    getValidationRules(fieldId, rules) {
        if (!rules){
            return null;
        }

        if (!fieldId) {
            return rules;
        }

        if (!rules[fieldId]) {
            return null;
        }

        var rulesForField = {};
        rulesForField[fieldId] = rules[fieldId];
        return rulesForField; 
    }
    _commonValidationRulesInit(rules, record) {
        const isExemptionOptionAvailable = _.has(rules, 'tfnExemptionReason');

        if (!record.hasTfnExemption || record.hasTfnExemption.length === 0) {
            delete rules.tfnExemptionReason;
            if (isExemptionOptionAvailable) {
                delete rules.tfnNumber;
                delete rules.tfnConsentFlag;
                delete rules.tfnWithConsent;
            }
        } else if (record.hasTfnExemption === ApplicationConstants.YesNoValues.NO) {
            delete rules.tfnExemptionReason;
        } else if (record.hasTfnExemption === ApplicationConstants.YesNoValues.YES) {
            delete rules.tfnNumber;
            delete rules.tfnConsentFlag;
            delete rules.tfnWithConsent;
        } 
        
        if (record && record.tfnNumber === YourDetailsConstants.Labels.tfnInfo.TFN_PROVIDED && record.tfnNumberReadonly) {
            if (record.tfnConsentFlag !== ApplicationConstants.YesNoValues.NO) {
                delete rules.tfnWithConsent;
            }
            delete rules.tfnNumber;
        } else {
            delete rules.tfnConsentFlag;
            delete rules.tfnWithConsent;
        }
    }
    validationRulesInit(rules, record, productId){
        if (rules.isAustralianResident && record.isAustralianResident !== ApplicationConstants.YesNoValues.NO){
            delete rules.countryOfResidence;
        }

        if(Products.isPension(productId) || Products.isAnnuity(productId)) {
            // for Pension & Annuity products we only display a single question about country
            delete rules.otherCountryTaxResidence2;
            delete rules.otherCountryTaxResidence3;
            delete rules.tin1;
            delete rules.tin2;
            delete rules.tin3;
            delete rules.tinExemptionReason1;
            delete rules.tinExemptionReason2;
            delete rules.tinExemptionReason3;
            delete rules.hasTinExemptionReason1;
            delete rules.hasTinExemptionReason2;
            delete rules.hasTinExemptionReason3;
        } 
        
        if (rules.isOtherCountryTaxResident) {
            // remove tax residence validation for australian tax residents
            if (record.isOtherCountryTaxResident !== ApplicationConstants.YesNoValues.YES) {
                for (var i = 1; i <= 3; i++) {
                    delete rules['otherCountryTaxResidence' + i];
                    delete rules['tin' + i];
                    delete rules['tinExemptionReason' + i];
                    delete rules['hasTinExemptionReason' + i];
                }
            } 

            // if neither country, tin or exemption supplied for tax residence records #2 & #3
            for (i = 2; i <= 3; i++) {
                if (!record['otherCountryTaxResidence' + i] && !record['tinExemptionReason' + i] && !record['tin' + i]) {
                    delete rules['tin' + i];
                    delete rules['tinExemptionReason' + i];
                    delete rules['otherCountryTaxResidence' + i];
                    delete rules['hasTinExemptionReason' + i];
                }
            }

            // if TIN or exemption choice has not been made, remove both TIN and exemption validation
            for (i = 1; i <= 3; i++) {
                if (!record['hasTinExemptionReason' + i]) {
                    delete rules['tinExemptionReason' + i];
                    delete rules['tin' + i];
                }
            }

            // Remove TIN or exemption validation depending on selection
            for (i = 1; i <= 3; i++) {
                if (record['hasTinExemptionReason' + i] === ApplicationConstants.YesNoValues.YES) {
                    delete rules['tin'+i];
                } else if (record['hasTinExemptionReason' + i] === ApplicationConstants.YesNoValues.NO) {
                    delete rules['tinExemptionReason' + i];
                }
            }
            
            // if tin or exemption is supplied, remove unnecessary validation 
            for (i = 1; i <= 3; i++) {
                if (record['tin'+i]) {
                    delete rules['tinExemptionReason' + i];
                } else if (record['tinExemptionReason' + i]) {
                    delete rules['tin' + i];
                }
            }
        }

        if (record.isCitizenOfOtherCountry !== ApplicationConstants.YesNoValues.YES) {
            delete rules.citizenship1;
        }

        if (record.hasTfnExemption === undefined) {
            record.hasTfnExemption = ApplicationConstants.YesNoValues.NO;
        }

        if (record.isOtherSourceOfFund === undefined || record.isOtherSourceOfFund === false) {
            delete rules.otherSourceOfFund;
        }

        if (record.isOtherSourceOfWealth === undefined || record.isOtherSourceOfWealth === false) {
            delete rules.otherSourceOfWealth;
        }

        this._commonValidationRulesInit(rules, record);
        
        return rules;
    }

    validationRulesForBusinessInit(rules, record){
        if (record.hasTfnExemption === undefined) {
            record.hasTfnExemption = ApplicationConstants.YesNoValues.NO;
        }

        this._commonValidationRulesInit(rules, record);
        return rules;
    }
    getAddressValidationRules(addressInfo, fieldId, withOutPostalAddress, isBusiness){
        var addressRule = this.getAddressRules();
        var addressRules = {};
        
        if (addressInfo.defineAddressLine === ApplicationConstants.YesNoValues.YES){
            addressRules = _.clone(addressRule.address);
            delete addressRules.residential;
            if (addressInfo.resCountry !== YourDetailsConstants.Values.COUNTRY_AUSTRALIA){
                delete addressRules.postCode;
                delete addressRules.resAusState;
            }
            if (isBusiness){
                addressRules.address1 = 'required|maxLength:30|businessAddressIsPoBox';
            }
        }
        else{
            addressRules['residential'] = (isBusiness) ? 'required|businessAddressIsPoBox' : addressRule.address.residential;
        }

        if (!withOutPostalAddress){
            if (addressInfo.isResPostalAdd === ApplicationConstants.YesNoValues.NO){
                if (addressInfo.definePostalAddressLine === ApplicationConstants.YesNoValues.YES){
                    assign(addressRules, _.clone(addressRule.postalAddress));
                    delete addressRules.postal;
                    if (addressInfo.postalCountry !== YourDetailsConstants.Values.COUNTRY_AUSTRALIA){
                        delete addressRules.postalPostCode;
                        delete addressRules.postalAusState;
                    }
                }
                else{
                    addressRules['isResPostalAdd'] = addressRule.postalAddress.isResPostalAdd;
                    addressRules['postal'] = addressRule.postalAddress.postal;
                }
            }
            else{
                addressRules['isResPostalAdd'] = addressRule.postalAddress.isResPostalAdd;
            }
        }
        //CEE-2: Bypassing field validations for existing customer if its readonly.
        if (addressInfo.addressLineReadonly) {
            delete addressRules.address1;
            delete addressRules.address2;
        }
        if (addressInfo.cityStatePostCodeReadonly) {
            delete addressRules.cityStatePostCode;
        }
        if (addressInfo.postCodeReadonly) {
            delete addressRules.postCode;
        }
        
        if (!fieldId){
            return addressRules;
        }
        else if (!addressRules[fieldId]) {
            return null;
        }

        var rulesForField = {};
        rulesForField[fieldId] = addressRules[fieldId];
        return rulesForField; 
    }
    
    // Adding validation rules for Mobile Number and Email Address fields
    validationRulesForContactDetails(rule, record) 
    {
        if (isAdviser() && record) {
            var str = record.mobileNumber;
            var mobileValue = String(str).replace(/\s/g, '');
            //Checking if mobile number field is non-editable and empty
            if(record.mobileNumberReadonly && (record.mobileNumber == null || record.mobileNumber == undefined || mobileValue.length ==0 )) {
                 rule.emailAddress += '|required';  
            }   
            // Adding rule to make either mobile number/email address mandatory 
            else {  
                 rule.mobileNumber += '|mobileNumberOrEmailRequired:' + (record.emailAddress == null || record.emailAddress == undefined) ?  '' : record.emailAddress;
                 rule.emailAddress += '|mobileNumberOrEmailRequired:' + (record.mobileNumber == null || record.mobileNumber == undefined) ?  '' : record.mobileNumber; 
            }
        }
        else {
            rule.mobileNumber += '|required';
            rule.emailAddress += '|required';
            
        }
      return rule;
    }
}

const YourDetailsValidations = new YourDetailsValidationsClass();

export default YourDetailsValidations;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/YourDetailsValidations.js